<template>
	<div class="row form-group">
		<div v-if="label" :class="`col-${colLabel}`">
			<label>{{ label }}:</label>
		</div>
		<div :class="`col-${colInput}`">
			<div class="group">
				<textarea
					:disabled="isView"
					class="form-control"
					type="text"
					:value="modelValue"
					@input="$emit('update:modelValue', $event.target.value)"
					ref="textAreaRef"
					:style="style"
				></textarea>
				<span class="highlight"></span><span class="bar"></span>
				<label
					:style="
						isView
							? { backgroundColor: '#ECEFF1' }
							: { backgroundColor: 'white' }
					"
					ref="placeholderRef"
					>{{ placeholder }}</label
				>
			</div>
		</div>
	</div>
</template>
<script setup>
import { ref, watch, computed } from "vue";
const textAreaRef = ref(null);
const props = defineProps({
	colLabel: {
		Type: Number,
		default: 3,
	},
	colInput: {
		Type: String,
		default: 5,
	},
	label: {
		Type: String,
	},
	placeholder: {
		Type: String,
	},
	modelValue: {
		Type: String,
	},
	style: {
		Type: Object,
	},
	isView: Boolean,
});
const placeholderRef = ref(null);
const padding = ref(null);
const height = ref(null);
watch(placeholderRef, () => {
	padding.value = placeholderRef.value.textContent
		? placeholderRef.value.offsetHeight
		: 10;
	height.value = placeholderRef.value.textContent
		? textAreaRef.value.offsetHeight - padding.value
		: 90;
});
const style = computed(() => ({
	paddingTop: `${padding.value}px`,
	minHeight: `${height.value}px`,
	...props.style,
}));

defineEmits(["update:modelValue"]);
defineExpose({ textAreaRef });
</script>
